export default "__VITE_ASSET__16NBoge3__"